@if (this.buttons.length > 0) {
<div class="avatar-footer-buttons">
    @for (button of this.buttons; track button) {
    <button
        class="btn btn-primary btn-sm"
        [ngClass]="button.className"
        (click)="onClick(button)"
    >{{ button.text }}</button>
    }
</div>
}